import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import TextField, { TextFieldProps } from '../text-field/TextField';

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
  prefix?: string;
  allowDecimal?: boolean;
  includeThousandsSeparator?: boolean;
}

const TextMaskCustom = (textMaskProps: TextMaskCustomProps | any) => {
  const {
    inputRef,
    maxLength,
    includeThousandsSeparator,
    allowDecimal,
    prefix,
    ...other
  } = textMaskProps;
  const numberMask = createNumberMask({
    prefix: prefix || '',
    integerLimit: maxLength || null,
    includeThousandsSeparator: includeThousandsSeparator || false,
    allowLeadingZeroes: true,
    allowDecimal: allowDecimal || false,
  });
  return (
    <MaskedInput
      data-testid={'numeric-text-field'}
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={numberMask}
      guide={false}
      showMask
    />
  );
};

const NumericTextField = React.forwardRef(
  (
    {
      prefix,
      allowDecimal,
      includeThousandsSeparator,
      ...props
    }: TextFieldProps | any,
    ref?: React.Ref<HTMLInputElement>,
  ) => {
    return (
      <TextField
        ref={ref}
        margin={'normal'}
        {...props}
        style={props.style || { width: '100%' }}
        InputProps={{
          ...props.InputProps,
          inputComponent: TextMaskCustom,
        }}
        inputProps={{
          maxLength: props.maxLength,
          minLength: props.minLength,
          prefix,
          allowDecimal,
          includeThousandsSeparator,
          ...props.inputProps,
          type: 'tel', // Use tel instead of number to avoid browser behaviour
        }}
      />
    );
  },
);
export default NumericTextField;
